import { render, staticRenderFns } from "./HomeRedesign.vue?vue&type=template&id=5c4e0a4f&scoped=true&"
import script from "./HomeRedesign.vue?vue&type=script&lang=js&"
export * from "./HomeRedesign.vue?vue&type=script&lang=js&"
import style0 from "./HomeRedesign.vue?vue&type=style&index=0&id=5c4e0a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e0a4f",
  null
  
)

export default component.exports